import styled from 'styled-components';

export const Container = styled.div<{ isPunchup?: boolean }>`
	display: flex;
	flex-direction: column;

	/* Override colors when isPunchup */
	${({ isPunchup }) =>
		isPunchup &&
		`
		* {
			color: #333 !important;
		}
	`}
`;
